import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import { useTreeHandlers } from 'components/WorkspaceEditor/hooks'
import {
    useHoveredItemActions,
    useShallowHoveredItems,
} from 'components/WorkspaceEditor/HoveredItemStore'
import React, { useCallback, useEffect, useMemo } from 'react'
import { DataNode } from '../../../types/types'

export const ClashDetectionDialog = () => {
    const {
        clashDetectionResponse,
        showClashDetectionDialog,
        hoveredNode,
    } = useShallowHoveredItems((state) => ({
        clashDetectionResponse: state.clashDetectionResponse,
        showClashDetectionDialog: state.showClashDetectionDialog,
        hoveredNode: state.hoveredNode,
    }))

    const {
        setShowClashDetectionDialog,
        setClashDetectionResponse,
    } = useHoveredItemActions()
    const { handleElementDeactivation } = useTreeHandlers()

    // Cleanup on unmount to prevent state leaks
    useEffect(() => {
        return () => {
            setShowClashDetectionDialog(false)
            setClashDetectionResponse(null)
        }
    }, [setShowClashDetectionDialog, setClashDetectionResponse])
    const dialogContent = useMemo(() => {
        if (hoveredNode?.isHidden) {
            return (
                <>
                    <span>
                        {clashDetectionResponse?.clashDetection.message}
                    </span>
                    <br />
                    <br />
                    <ul style={{ color: 'black' }}>
                        {clashDetectionResponse?.clashDetection?.clashedProductTypes?.map(
                            (item, index) => {
                                return (
                                    <li key={index}>
                                        {item.productType}
                                        {item.productTypeParentAssemblies
                                            ? ` (${item.productTypeParentAssemblies.join(
                                                  ', '
                                              )})`
                                            : ''}
                                    </li>
                                )
                            }
                        )}
                    </ul>
                    <br />
                    <span>Are you sure you want to proceed?</span>
                </>
            )
        } else {
            return (
                <>
                    <span>
                        This content is required based on your selected Product
                        Type.
                    </span>
                    <br />
                    <span>Are you sure you want to inactivate it?</span>
                </>
            )
        }
    }, [clashDetectionResponse, hoveredNode])

    const dialogHeading = useMemo(
        () =>
            hoveredNode?.isHidden
                ? 'Clash Detected'
                : 'Product Type Automation',
        [hoveredNode]
    )

    const handleCloseClashDialog = useCallback(() => {
        setShowClashDetectionDialog(false)
    }, [setShowClashDetectionDialog])

    const handleConfirmClashDialog = useCallback(async () => {
        if (!hoveredNode) return

        await handleElementDeactivation(
            !(hoveredNode.isHidden ?? false),
            hoveredNode as DataNode
        )
        handleCloseClashDialog()
    }, [handleElementDeactivation, hoveredNode, handleCloseClashDialog])
    if (!showClashDetectionDialog) return null

    return (
        <ConfirmationDialog
            openDialog={showClashDetectionDialog}
            handleDialogClose={handleCloseClashDialog}
            dialogActionCallback={handleConfirmClashDialog}
            dialogHeading={dialogHeading}
            confirmText="Yes"
            confirmMessage=""
            contentNode={dialogContent}
            contentStyles={{ padding: '20px 0' }}
            size="default"
            removeHeaderBorder
        />
    )
}
